import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';

import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { Location } from '@angular/common'

@Component({
	selector: 'app-prodline-markups',
	templateUrl: './prodline-markups.component.html',
	styleUrls: ['./prodline-markups.component.scss']
})
export class ProdlineMarkupsComponent implements OnInit {

	@Input() line_field;
	@Output() updateProductLines = new EventEmitter < boolean > ();
	plmdata: any = [];
	plvs: any = [];
	loading: boolean = false;

	constructor(private fb: UntypedFormBuilder, private location: Location, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService) {}

	ngOnInit(): void {

		this.getData()
		this.globalSearchService.all_system_types.subscribe((alltypes: any) => {
			if (alltypes) {
				this.plvs = alltypes.salestypes;
			}
		});
	}

	getFallBack(pline: any, type:any) {
		const substitute = this.plvs.filter(r => {
			return (r.typeabbrev == type && pline == r.line_field)
		})[0];

		if(substitute) {
			return substitute;
		}

		return false;
	}

	isValidPLM(plm: any): boolean {
		return plm.typeabbrev && 
		       plm.pricebasis && 
		       plm.operator && 
		       plm.amount && 
		       !isNaN(parseFloat(plm.amount)) &&
		       parseFloat(plm.amount) >= 0;
	}

	getValidationError(plm: any): string {
		if (!plm.typeabbrev) return 'Price Level is required';
		if (!plm.pricebasis) return 'Price Basis is required';
		if (!plm.operator) return 'Operator is required';
		if (!plm.amount) return 'Amount is required';
		if (isNaN(parseFloat(plm.amount))) return 'Amount must be a valid number';
		if (parseFloat(plm.amount) < 0) return 'Amount must be greater than or equal to 0';
		return '';
	}

	// Helper methods for template
	parseFloat = parseFloat;
	isNaN = isNaN;

	isAmountValid(plm: any): boolean {
		return plm.amount && !isNaN(parseFloat(plm.amount));
	}

	isAmountPositive(plm: any): boolean {
		return plm.amount && !isNaN(parseFloat(plm.amount)) && parseFloat(plm.amount) >= 0;
	}

	getData() {
		const data = { line_field: this.line_field };
		this.globalsService.getProdLineMarkups(data).subscribe((results: any) => {
			this.plmdata = results;
		});
	}

	addPLM() {
		this.plmdata.push({
			editing: 1,
			id: '',
			line_field: this.line_field,
			typeabbrev: '',
			operator: '',
			amount: '0'
		});
	}

	deletePLM(plm: any) {
		if (!confirm('Are you sure you want to delete this markup?')) {
			return;
		}

		this.loading = true;
		plm.errorMessage = '';
		
		const data = { id: plm.id };
		this.globalsService.deleteProdLineMarkup(data).subscribe({
			next: (results: any) => {
				if(results.success) {
					this.getData();
				} else {
					plm.errorMessage = results.message;
				}
				this.loading = false;
			},
			error: (error) => {
				plm.errorMessage = 'Failed to delete markup: ' + error.message;
				this.loading = false;
			}
		});
	}

	savePLM(plm: any) {
		// Clear any previous error messages
		plm.errorMessage = '';

		// Validate the form
		if (!this.isValidPLM(plm)) {
			plm.errorMessage = this.getValidationError(plm);
			return;
		}

		this.loading = true;

		const data = {
			line_field: plm.line_field,
			id: plm.id,
			typeabbrev: plm.typeabbrev,
			operator: parseInt(plm.operator), // Convert string to number
			amount: parseFloat(plm.amount),   // Convert string to number
			pricebasis: plm.pricebasis
		};

		this.globalsService.saveProdLineMarkup(data).subscribe({
			next: (results: any) => {
				this.plmdata = results;
				this.updateProductLines.emit(true);
				this.loading = false;
			},
			error: (error) => {
				plm.errorMessage = 'Failed to save markup: ' + error.message;
				this.loading = false;
			}
		});
	}

	cancelPLM() {
		this.getData();
	}

}
